
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tos",
      function () {
        return require("private-next-pages/tos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tos"])
      });
    }
  